import { formatReportDate, formatReportTime } from '@/utils/formatters';

export const levelColors = ['#FF9F4C', '#E11560', '#2BAE19', '#973D9D', '#05ABF4'];

export const timeString = formatReportTime;
export const dateString = formatReportDate;

export const reportSkillsList = [
  { id: 2, name: 'grammar' },
  { id: 3, name: 'speak' },
  { id: 1, name: 'listen' },
  { id: 5, name: 'vocabulary' },
  { id: 7, name: 'read' },
  { id: 4, name: 'spelling' },
];

export const roundNumber = (num: number, decimalPlaces: number = 0) => {
  const decimal = Math.pow(10, decimalPlaces);
  return Math.round(num * decimal) / decimal;
};
